import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Event} from '../models/event';
import {ProductItem} from '../models/product';
import {Ordered} from '../models/ordered';
import {Enrollment} from '../models/enrollment';

@Injectable({
  providedIn: 'root'
})
export class CertificateService {

  constructor (
    private db: AngularFirestore
  ) { }


  select (isCongress: boolean) {

    return this.db.collection<Event>('sbccv_events', ref => ref
      .where('congress', '==', isCongress)
      .where('deleted', '==', false)
      .orderBy('startDay', 'desc')
      .orderBy('name', 'asc')
    ).get()

  }

  getById (id) {
    return this.db.doc<Event>('sbccv_events/' + id)
      .get();
  }

  async _getSubscriptions (event_id) {
    return this.db.collection<ProductItem>('sbccv_product_itens', ref => ref
      .where('event_id', '==', event_id)
      .limit(1))
      .get()
      .subscribe((result) => {
        result.forEach(async (item) => {
          const product_id = item.data().product_id
          console.log('sbccv_product_itens ' + product_id)

          return this.db.collection<Ordered>('sbccv_orders', ref => ref
            .where('product_id', '==', product_id)
            .where('returnCode', '==', '00')
            .orderBy('date', 'desc'))
            .get()
            .subscribe((resultOrders) => {

              const subscriptions: any[] = []
              resultOrders.forEach(async (order) => {
                subscriptions.push({
                  'member_id': order.data().member_id,
                  'member_name': order.data().member_name,
                  'member_email': order.data().member_email,
                  'selected': false,
                })
              })

              return subscriptions
            })

        })

      })
  }

  getProductId (event_id) {
    return this.db.collection<ProductItem>('sbccv_product_itens', ref => ref
      .where('event_id', '==', event_id))
      .get()
  }

  getSubscriptions (product_id) {
    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .where('product_id', '==', product_id)
      .where('returnCode', '==', '00')
      .orderBy('date', 'desc'))
      .get()
  }

  async getSubscriptionsAndEnrollments (event_id, product_id) {

    const subscriptionsPromise = new Promise((resolve) => {

      return this.db.collection<Ordered>('sbccv_orders', ref => ref
        .where('product_id', '==', product_id)
        .where('returnCode', '==', '00')
        .orderBy('date', 'desc'))
        .get()
        .subscribe((subscriptions) => {
          const arraySubscription: any[] = [];
          subscriptions.forEach((subscription) => {
            arraySubscription.push(this.makeSubcription(subscription))
          })

          resolve(arraySubscription)
        })

    })

    const enrollmentsPromise = new Promise((resolve) => {
      return this.db.collection<Enrollment>('sbccv_enrollment', ref => ref
        .where('event_id', '==', event_id)).snapshotChanges()
        .subscribe((enrollments) => {
          const arrayEnrollments: any[] = [];
          enrollments.forEach((enrollment) => {
            arrayEnrollments.push(this.makeEnrollment(enrollment))
          })
          resolve(enrollmentsPromise)
        })
    })

    return (await Promise.all([ subscriptionsPromise, enrollmentsPromise ]));

  }

  makeSubcription (item): any {
    let subcription : any = {}

    subcription.id = item.payload.doc.id;
    subcription.date = item.payload.doc.data().date;
    subcription.product_id = item.payload.doc.data().product_id;
    subcription.product_name = item.payload.doc.data().product_name;
    subcription.topic_name = item.payload.doc.data().topic_name;
    subcription.member_name = item.payload.doc.data().member_name;
    subcription.category_name = item.payload.doc.data().category_name;

    return subcription
  }

  makeEnrollment (item): Enrollment {

    let enrollment = new Enrollment()

    enrollment.id = item.payload.doc.id;
    enrollment.created = new Date()

    enrollment.event_id = item.payload.doc.data().event_id;
    enrollment.event_name = item.payload.doc.data().event_name;

    enrollment.day_id = item.payload.doc.data().day_id;
    enrollment.day_name = item.payload.doc.data().day_name;

    enrollment.activity_id = item.payload.doc.data().activity_id;
    enrollment.activity_name = item.payload.doc.data().activity_name;

    enrollment.topic_id = item.payload.doc.data().topic_id;
    enrollment.topic_name = item.payload.doc.data().topic_name;

    enrollment.finished = item.payload.doc.data().finished;
    enrollment.member_id = item.payload.doc.data().member_id;
    enrollment.member_name = item.payload.doc.data().member_name;
    enrollment.type = item.payload.doc.data().type;

    enrollment.certificate_url = item.payload.doc.data().certificate_url || '';

    return enrollment
  }

}
